import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';
import type { ConvertToLivePageProps } from './ConvertToLivePageDialog.tsx';

export const ConvertToLivePageDialog: LoadableType<ConvertToLivePageProps> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ConvertToLivePageDialogLoadable" */ './ConvertToLivePageDialog.tsx'
			)
		).ConvertToLivePageDialog,
});
